function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ic_quick_order");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "B2B_Bulk_Order_copypaste_3",
  transform: "translate(-1000.000000, -64.000000)"
}, React.createElement("g", {
  id: "Group-5"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(1.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-9",
  transform: "translate(907.000000, 48.000000)"
}, React.createElement("g", {
  id: "ic_quick_order",
  transform: "translate(92.000000, 16.000000)"
}, React.createElement("g", {
  id: "Path-9"
}, React.createElement("path", {
  d: "M5.38469978,7.68211004 L9.25554324,7.68211004 C9.39361442,7.68211004 9.50554324,7.79403885 9.50554324,7.93211004 C9.50554324,7.98235609 9.49040272,8.03143622 9.46209609,8.07295009 L2.69324144,18 L4.15585254,10.31789 L0.285009079,10.31789 C0.146937892,10.31789 0.0350090794,10.2059612 0.0350090794,10.06789 C0.0350090794,10.0176439 0.0501496,9.96856378 0.0784562292,9.92704991 L6.84731087,-1.42108547e-14 L5.38469978,7.68211004 Z"
}))))))));

var SvgBulkCart = function SvgBulkCart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "18px",
    viewBox: "0 0 10 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBulkCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bulk-cart.df81869c.svg";
export { ForwardRef as ReactComponent };